import angular from 'angular'

import areaAsk from './services/ask.service'
import areaData from './services/data.service'
import areaFormat from './services/format.service'
import areaGo from './services/go.service'
import areaLocal from './services/local.service'
import areaMetadata from './services/metadata.service'
import areaRequest from './services/request.service'
import areaResource from './services/resource.service'
import area from './services/area.service'

import myAreaDisplay from './directives/display/myAreaDisplay'
import myAreaChart from './directives/display/myAreaChart'
import myAreaForm from './directives/forms/myAreaForm'
import myAreaCreateForm from './directives/forms/myAreaCreateForm'
import myAreaEditForm from './directives/forms/myAreaEditForm'

import areaButtons from './resources/buttons.resource'
import areaIcons from './resources/icons.resource'
import areaFields from './resources/fields.resource'
import areaLabels from './resources/labels.resource'

const name = 'area'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('areaAsk', areaAsk)
  .factory('areaData', areaData)
  .factory('areaFormat', areaFormat)
  .factory('areaGo', areaGo)
  .factory('areaLocal', areaLocal)
  .factory('areaMetadata', areaMetadata)
  .factory('areaRequest', areaRequest)
  .factory('areaResource', areaResource)
  .factory('$$area', area)
  // ===== DIRECTIVES ===== //
  .directive('myAreaDisplay', myAreaDisplay)
  .directive('myAreaChart', myAreaChart)
  .directive('myAreaForm', myAreaForm)
  .directive('myAreaCreateForm', myAreaCreateForm)
  .directive('myAreaEditForm', myAreaEditForm)
  // ===== RESOURCES ===== //
  .factory('areaButtons', areaButtons)
  .factory('areaIcons', areaIcons)
  .factory('areaFields', areaFields)
  .factory('areaLabels', areaLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/area.module.js